import { createAsyncThunk } from '@reduxjs/toolkit';
import { createOrder } from '../../api/create-order';

type CreateOrderThunkRequestItem = {
    name: string,
    count: number,
    price?: number,
    url: string,
}

type CreateOrderThunkRequest = {
    name: string,
    phone: string,
    email: string,
    date: number,
    address: string,
    comment?: string,
    items: CreateOrderThunkRequestItem[]
}

export const createOrderThunk = createAsyncThunk(
    'createOrderThunk',
    async ({
        name,
        phone,
        email,
        date,
        address,
        comment,
        items,
    }: CreateOrderThunkRequest) => createOrder({
        name,
        phone,
        email,
        date,
        address,
        comment,
        items,
    }),
);
